import { useSelectionStore } from "../stores/selectionStore";
import { requestInspectorChromeFlash } from "./inspectorChromeFlash";
import { logger } from "./logger";

/** Set when creating from the docked properties panel: select the new entity but do not expand the inspector. */
export const INSPECTOR_ADD_NO_REVEAL_SOURCE = "inspectorAddNoReveal";

/**
 * After creating an entity, run `applySelection` (typically `select*` on the selection store),
 * then bump `selectionSequence` via `setLastSelectionSource` and, by default, expand the properties panel.
 *
 * `applySelection` must run before `setLastSelectionSource` so `PropertiesPanelManager`'s
 * `selectionSequence` effect sees a non-null `activePanel` on the same tick.
 *
 * @param {string} source — stored as `lastSelectionSource` when {@link openPropertiesPanel} is true
 * @param {() => void} applySelection
 * @param {{ openPropertiesPanel?: boolean; duplicateChromeFlash?: boolean }} [options] — set `openPropertiesPanel: false` for in-inspector "add" (not context menus)
 */
export function focusNewEntityInInspector(source, applySelection, options = {}) {
  const { openPropertiesPanel = true, duplicateChromeFlash = false } = options;
  if (typeof applySelection !== "function") return;
  applySelection();
  try {
    const effectiveSource = openPropertiesPanel ? source : INSPECTOR_ADD_NO_REVEAL_SOURCE;
    useSelectionStore.getState().setLastSelectionSource(effectiveSource);
  } catch (error) {
    logger.warn("[focusNewEntityInInspector] setLastSelectionSource failed", error);
  }
  if (openPropertiesPanel) {
    try {
      if (typeof window !== "undefined") {
        window.dispatchEvent(new CustomEvent("open-properties-panel"));
      }
    } catch {
      // ignore
    }
  }
  if (duplicateChromeFlash) {
    requestInspectorChromeFlash();
  }
}
